import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as strikeOutButtonWithColorQuestionItemStyle } from "./StrikeOutButtonWithColorQuestionItem.style";
const StrikeOutButtonWithColorQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = state === QuestionItemState.SELECTED;
    const style = useMemo(() => strikeOutButtonWithColorQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "strike-out-button-with-color-question-item" },
        React.createElement(Button, { checked: checked, style: { button: style.button, text: checked && style.buttonText }, testID: question.id, title: titleText, onPress: handleOnChange },
            React.createElement(View, { style: [{ backgroundColor: question.metadata.color }, style.color] }))));
};
export { StrikeOutButtonWithColorQuestionItem };
